import { AbstractControl, ValidationErrors } from '@angular/forms';

import { isAfter, parse } from 'date-fns';
import { endOfToday } from 'date-fns';

export function noFutureDate(control: AbstractControl): ValidationErrors | null {
  if (!control.value || control.value.length < 1) {
    return null;
  }

  const date = parse(control.value, 'MM/dd/yyyy', new Date());
  // date is valid and before current time
  if (isAfter(date, endOfToday())) {
    return {futureDate: true};
  }

  return null;
}
